import {HashKeyMap} from "../../../js/classes/hash-map/HashKeyMap";
import {CodeAndExchange, securityHash} from "../../../instruments/types/CodeAndExchange";

export type SecurityMap<V> = HashKeyMap<CodeAndExchange, V>;

export function SecurityMapOf<V>(): SecurityMap<V> {
    return HashKeyMap.of<CodeAndExchange, V>(securityHash);
}
